/** Isolated 06 fixtures. Manufacturer descriptions are examples, never verified capability. */
export const PROVIDER_BASE = '/demo/technology-solutions/provider-portal';

export const providerTabs = [
  '产品概览',
  '技术参数',
  '功能与技术',
  '图片与资料',
  '版本与反馈',
] as const;

export type ProviderTab = (typeof providerTabs)[number];
